import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'

const BASE_URL = util.API_URL;

const INITIAL_VALUES = {

}


export function getList(tipo = "", valor = "", unidades, offset = 0, limit = 15) {
    const request = axios.get(`${BASE_URL}/boletos`, {
        headers: {
            tipo,
            valor,
            offset,
            limit,
            unidades
        }
    })
    return {
        type: 'BOLETO_FETCHED',
        payload: request
    }
}

export function create(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/bolav`, values)
            .then(resp => {
                if (resp.data.errors !== undefined) {
                    resp.data.errors.forEach(error => toastr.error('Atenção', error))
                } else {
                    toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                }

                dispatch(initFormCreat())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    let isCadastrou = e.response.data.errors[0] === 'Boleto cadastrado no banco de dados mas não registrado!'
                    if (isCadastrou) {
                        toastr.warning('Atenção', e.response.data.errors[0])
                        e.response.data.errors.splice(0, 1);
                    }
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                    if (isCadastrou) {
                        dispatch(initFormCreat())
                    }
                }
            })
    }
}

export async function imprimir(values) {

    return dispatch => {
        axios['get'](`${BASE_URL}/printAv`, {
            headers: {
                idboleto: values.id,
                'Accept': 'application/pdf',
            }, responseType: 'arraybuffer'
        })
            .then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                window.open(url, "_blank");
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })

    }
}


export function sendBoleto(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/boleto/registrar`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(initFormCreat())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function update(values) {
    return dispatch => {
        axios['post'](`${BASE_URL}/boletos`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function remove(values) {
    return dispatch => {
        axios['put'](`${BASE_URL}/boletos`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

function submit(values, method) {
    return dispatch => {
        axios[method](`${BASE_URL}/bolav`, values)
            .then(resp => {
                toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                dispatch(init())
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}

export function showUpdate(boleto) {

    return [
        showTabs('tabUpdate'),
        selectTab('tabUpdate'),
        initialize('boletoForm', boleto)
    ]
}

/* TODO refatorar para utilizar um metodo so com o showupdate*/
export function showDelete(boleto) {
    return [
        showTabs('tabDelete'),
        selectTab('tabDelete'),
        initialize('boletoForm', boleto)
    ]
}

export function showView(boleto) {
    return [
        showTabs('tabView'),
        selectTab('tabView'),
        initialize('boletoFormView', boleto)
    ]
}


export function initFormCreat() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        initialize('boletoFormCreate', INITIAL_VALUES)
    ]
}

export function init() {
    return [
        showTabs('tabList', 'tabCreate'),
        selectTab('tabList'),
        getList(),
        initialize('boletoForm', INITIAL_VALUES)
    ]
}


// WEBPACK FOOTER //
// ./src/boleto/boletoAction.js